import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import Rocket from "../assets/stage.gif";
import {
  LandingHassle,
  LandingFundraising,
  LandingAngel,
  LandingReimagined,
  HowItWorks,
MessageSlider,
TextCarousel,
IndustryCarousel
} from "@peterfosso/prairi-components";
import { navBarContext } from "./context/context";
import Phone from "../assets/matchphone.png";
import Map from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useWindowDimensions } from "../utils"
import { db, getDoc, doc, updateDoc } from "../firebase/firebaseApp";
import { analytics } from "../firebase/firebaseApp";
import { logEvent } from "firebase/analytics";

const AdLanding = () => {
  let navigate = useNavigate();
  const sectionRef = useRef(null);
  const { width, height } = useWindowDimensions();
  const deviceWidth = parseFloat(width);
  const deviceHeight = parseFloat(height);
    let { docId } = useParams() || null;
    const [data, setData] = useState({
      username: "",
    });
  const [loading, setLoading] = useState(true);

  const industries = [
  { text: "AdTech/Media", font: "sans-serif" },
  { text: "Big Data", font: "monospace" },
  { text: "Consumer Goods", font: "serif" },
  { text: "Cybersecurity", font: "monospace" },
  { text: "Deep Tech (AI, Web3, Blockchain, etc.)", font: "Raleway, sans-serif" },
  { text: "Emerging Tech (NFTs, VR, Robotics)", font: "Impact, Haettenschweiler, Arial Narrow Bold, sans-serif" },
  { text: "eCommerce", font: "sans-serif" },
  { text: "EdTech", font: "Dancing Script" },
  { text: "Entertainment/Music/Gaming", font: "Bungee" },
  { text: "Fashion", font: "Pacifico" },
  { text: "FoodTech", font: "serif" },
  { text: "Fintech/Finance", font: "monospace" },
  { text: "Greentech/Cleantech/Energy", font: "serif" },
  { text: "HealthTech/MedTech", font: "sans-serif" },
  { text: "IT/Software/SaaS", font: "monospace" },
  { text: "PropTech", font: "sans-serif" },
  { text: "Retail", font: "serif" },
  { text: "Service Industry Solutions", font: "sans-serif" },
  { text: "Space Technology", font: "monospace" },
  { text: "Transport and Logistics (Shared Mobility/Maritime/Delivery Services)", font: "serif" },
];

const countries = [
  { text: "Australia", font: "sans-serif" },
  { text: "Cayman Islands", font: "monospace" },
  { text: "Chile", font: "serif" },
  { text: "Denmark", font: "Raleway, sans-serif" },
  { text: "Estonia", font: "Impact, Haettenschweiler, Arial Narrow Bold, sans-serif" },
  { text: "Finland", font: "Dancing Script" },
  { text: "Germany", font: "Bungee" },
  { text: "Hong Kong", font: "Pacifico" },
  { text: "Iceland", font: "serif" },
  { text: "India", font: "monospace" },
  { text: "Latvia", font: "sans-serif" },
  { text: "Netherlands", font: "serif" },
  { text: "Norway", font: "monospace" },
  { text: "Spain", font: "sans-serif" },
  { text: "Sweden", font: "serif" },
  { text: "Switzerland", font: "monospace" },
  { text: "United Arab Emirates", font: "sans-serif" },
  { text: "United Kingdom", font: "serif" },
  { text: "United States", font: "monospace" }
];

    const handleClick = () => {
      if (docId){
        navigate(`/invited/${docId}`)
      }
      else{
        navigate(`/invitation/startup/stripe`)
      }
    }
  const handleScroll = () => {
    if (sectionRef.current) {
      const elementTop = sectionRef.current.offsetTop;
      const scrollPosition = elementTop - navBarHeight;
      window.scrollTo({ top: scrollPosition, behavior: "smooth" });
    }
    if (analytics) {
      logEvent(analytics, "how_it_works_click_startup", {
        page: "startup_landing",
        path: window.location.pathname
      });
    }
  };
  const sliderMessages = [<div><span className="font-bold mr-1">New Feature! </span> Pitch decks display automatically to investors on a PC/laptop</div>,
    <div className="flex"><img alt="rocket icon" src={Rocket} className="w-[20px] h-[20px] mr-2"/> New! Check out our new <span className="font-bold mx-1">deal tracking</span> feature!</div>
]
const sliderColors = ["#204549"]

  useEffect(() => {
    const fetchDocumentData = async () => {
      if (docId){
        try {
          const docRef = doc(db, "preUsers", docId); //now fetches from preUsers so it can read
          const docData = await getDoc(docRef);
          if (docData.exists()) {
            const docInfo = docData.data();
  setData({ username: docInfo.username || "" });
          } else {
            //console.log("No such document!");
          }
          setLoading(false);
        } catch (error) {
          //console.error("Error fetching document:", error);
          setLoading(false);
        }
      }
      else{
        data.username = "";
      }

    };

    fetchDocumentData();
  }, [docId]);

const [viewport, setViewPort] = useState({
  latitude: 0,
  longitude: 0,
  zoom: 1
})
  const { navBarHeight } = useContext(navBarContext);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`px-0 pb-0 w-full pt-28`}>

      <LandingHassle click={handleClick} how={handleScroll} name={!loading && data.username ? `${data.username.split(" ")[0]}` : false}/>
        {/* <div className="w-full flex justify-center">
        <Map
      // https://visgl.github.io/react-map-gl/docs/get-started/mapbox-tokens
      mapboxAccessToken="pk.eyJ1IjoiZ2F0b2xhaWxhIiwiYSI6ImNtN3Ywb2I5MDA3M3cybG9qcDN4eHk4dXoifQ.EqN5d2ovtoMeBF9ba_cNLA"
      initialViewState={viewport}
      style={{width: deviceWidth, height: deviceHeight/2}}
      mapStyle="mapbox://styles/mapbox/streets-v9"
    />
        </div> */}
        <TextCarousel words={industries}/>
              <LandingAngel  click={handleClick}/>
              <TextCarousel words={countries}/>
<div className="w-full flex justify-center">

</div>
<div ref={sectionRef}>
      <HowItWorks click={handleClick}/>
        </div>
      <LandingReimagined click={handleClick}/>


    </div>
  );
};

export default AdLanding;